import { t } from "@lingui/core/macro";

import { LoadingScreenInternal } from "./internal";

type LoadingScreenProps = {
  ariaLabel?: string;
  wScreenDisabled?: boolean;
  hScreenDisabled?: boolean;
};

export function LoadingScreen({ ariaLabel, wScreenDisabled, hScreenDisabled }: LoadingScreenProps) {
  return (
    <LoadingScreenInternal
      wScreenDisabled={wScreenDisabled}
      hScreenDisabled={hScreenDisabled}
      ariaLabel={ariaLabel ?? t`Loading`}
    />
  );
}
